import React, { ReactNode, useId } from 'react';
import {
  HiddenInput,
  RadioButtonCard,
  RadioButtonContent,
  RadioButtonIcon,
  RadioButtonLabel,
  RadioButtonText,
} from './radio-button.styles';
import { CustomRadio } from './radio.styles';

interface Props {
  icon: ReactNode;
  text: ReactNode;
  checked: boolean;
  name: string;
  value: string | number;
  disabled?: boolean;
  id?: string;
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButton = ({
  icon,
  text,
  checked,
  name,
  value,
  disabled,
  id,
  className,
  onChange,
}: Props) => {
  const generatedId = useId();
  const inputId = id || generatedId;

  return (
    <RadioButtonLabel
      htmlFor={inputId}
      $disabled={disabled}
      className={className}>
      <HiddenInput
        id={inputId}
        type='radio'
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <RadioButtonCard $disabled={disabled}>
        <RadioButtonContent>
          <RadioButtonIcon>{icon}</RadioButtonIcon>
          <RadioButtonText>{text}</RadioButtonText>
        </RadioButtonContent>
        <CustomRadio />
      </RadioButtonCard>
    </RadioButtonLabel>
  );
};

export default RadioButton;
